export interface EmojiItem {
  code: string[];
  emoji: string;
  name: string;
  category: string;
  subcategory: string;
}

export const searchEmojiItems = (
  emojiList: EmojiItem[],
  searchTerm: string,
  options?: {
    searchInName?: boolean;
    searchInCategory?: boolean;
    searchInSubcategory?: boolean;
    caseSensitive?: boolean;
  }
): EmojiItem[] => {
  if (!searchTerm.trim()) return emojiList;

  const {
    searchInName = true,
    searchInCategory = false,
    searchInSubcategory = false,
    caseSensitive = false,
  } = options || {};

  const term = caseSensitive ? searchTerm : searchTerm.toLowerCase();

  return emojiList.filter((emoji) => {
    const nameMatch =
      searchInName &&
      (caseSensitive ? emoji.name : emoji.name.toLowerCase()).includes(term);

    const categoryMatch =
      searchInCategory &&
      (caseSensitive ? emoji.category : emoji.category.toLowerCase()).includes(
        term
      );

    const subcategoryMatch =
      searchInSubcategory &&
      (caseSensitive
        ? emoji.subcategory
        : emoji.subcategory.toLowerCase()
      ).includes(term);

    return nameMatch || categoryMatch || subcategoryMatch;
  });
};

export const getPopularEmojiItems = (
  emojiList: EmojiItem[],
  limit: number = 100
): EmojiItem[] => {
  const popularEmojiKeywords = [
    "grinning",
    "laughing",
    "smiling",
    "heart",
    "thumbs",
    "fire",
    "clapping",
    "pray",
    "ok",
    "victory",
    "fist",
    "wave",
    "pointing",
    "eyes",
    "ear",
    "nose",
    "mouth",
    "tongue",
    "brain",
    "bone",
    "tooth",
    "muscle",
    "leg",
    "foot",
    "hand",
    "star",
    "check",
    "cross",
    "warning",
    "information",
    "question",
    "exclamation",
    "diamond",
    "sparkle",
    "music",
    "sport",
    "food",
    "drink",
    "animal",
    "plant",
    "weather",
    "time",
    "money",
    "love",
    "celebration",
    "activity",
    "travel",
    "object",
    "symbol",
    "flag",
  ];

  const popular = emojiList.filter((emoji) =>
    popularEmojiKeywords.some((keyword) =>
      emoji.name.toLowerCase().includes(keyword)
    )
  );

  if (popular.length < limit) {
    const remaining = emojiList.filter(
      (emoji) =>
        !popular.some((pop) => pop.code.join("-") === emoji.code.join("-"))
    );

    const categoryMap = new Map<string, EmojiItem[]>();
    remaining.forEach((emoji) => {
      if (!categoryMap.has(emoji.category)) {
        categoryMap.set(emoji.category, []);
      }
      categoryMap.get(emoji.category)!.push(emoji);
    });

    const diverseEmojis: EmojiItem[] = [];
    const categories = Array.from(categoryMap.keys());
    let categoryIndex = 0;
    while (
      diverseEmojis.length < limit - popular.length &&
      categories.length > 0
    ) {
      const category = categories[categoryIndex % categories.length];
      const categoryEmojis = categoryMap.get(category)!;
      if (categoryEmojis.length > 0) {
        diverseEmojis.push(categoryEmojis.shift()!);
      }
      categoryIndex++;
    }

    return [...popular, ...diverseEmojis];
  }

  return popular.slice(0, limit);
};
